import React, { createContext, useContext, useState } from 'react';

const GroupStateContext = createContext(null);


export const GroupStateProvider = ({ children }) => {
    const [groupState, setGroupState] = useState(null);


    return (
        <GroupStateContext.Provider value={{ groupState, setGroupState }}>
            {children}
        </GroupStateContext.Provider>
    );
};

export const useGroupState = () => useContext(GroupStateContext);
